import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Grid, xcss } from '@atlaskit/primitives';

import { EndOfPageCard } from '@confluence/page-card/entry-points/EndOfPageCard';
import type { GlobalPageCard } from '@confluence/page-card/entry-points/cardTypes';

export type EndOfPageRecGridProps = {
	pageCardData: GlobalPageCard[];
	pageRecStrategy?: string[][];
	entityId: string;
	isCompact?: boolean;
};

const TwoCardWrapperWidth = xcss({
	maxWidth: '480px',
});

const ThreeCardWrapperWidth = xcss({
	maxWidth: '320px',
});

const BigCardHeight = xcss({
	height: '128px',
});

const getColumnsBasedOnNumberOfCards = (totalCards: number) => {
	const fixedTwoColumns = '1fr 1fr';
	const autoFitColumns = 'repeat(auto-fit, minmax(320px, 1fr))';
	switch (totalCards) {
		case 1:
		case 2:
			return fixedTwoColumns;
		default:
			return autoFitColumns;
	}
};

const getCardStyles = (totalCards: number) => {
	let stylesArray;
	switch (totalCards) {
		case 1:
		case 2:
		case 4:
			stylesArray = [TwoCardWrapperWidth];
			break;
		default:
			stylesArray = [ThreeCardWrapperWidth];
			break;
	}
	stylesArray.push(BigCardHeight);
	return stylesArray;
};

export const EndOfPageRecGrid = ({
	pageCardData,
	pageRecStrategy,
	entityId,
	isCompact,
}: EndOfPageRecGridProps) => {
	return (
		<Grid
			templateColumns={getColumnsBasedOnNumberOfCards(pageCardData.length)}
			gap="space.200"
			role="list"
		>
			{pageCardData.map((node, i) => (
				<Box key={node.id} xcss={() => getCardStyles(pageCardData.length)} role="listitem">
					<EndOfPageCard
						data={node}
						ranking={i}
						analyticsData={{
							source: 'endOfPageRecommendations',
							attributes: {
								strategy: pageRecStrategy ? pageRecStrategy[i % pageRecStrategy.length] : null,
								mainContentId: entityId,
							},
						}}
						isCompactView={isCompact}
						showCardsAsListitem={false}
					/>
				</Box>
			))}
		</Grid>
	);
};
